import { RelatedItemsSection } from 'components/related-items';
import { useScenarioForm } from './contexts';
import styles from './area-related-documents.module.scss';

interface Props {
  areaIndex: number;
  /** The persisted scenario's id; absent in create mode (no saved areas exist). */
  scenarioId?: string;
}

// Related Documents per area (10-SFD): the shipped Related Items widget mounted on a
// SAVED area config. The picker POSTs each row (files included) against a persisted
// host, so an unsaved area has no host id yet — it shows a disabled save-first hint
// and issues no request, matching the shipped picker's saved-host contract.
export function AreaRelatedDocuments({
  areaIndex,
  scenarioId,
}: Props): JSX.Element {
  const { form } = useScenarioForm();

  return (
    <form.Subscribe
      selector={(state) => ({
        id: state.values.areas[areaIndex]?.id,
        status: state.values.areas[areaIndex]?.status,
      })}
    >
      {({ id, status }) => {
        const saved =
          status === 'saved' && scenarioId !== undefined && id !== undefined;

        if (!saved) {
          return (
            <p className={styles.savePrompt} aria-disabled="true">
              Save the scenario to add documents.
            </p>
          );
        }

        return (
          <RelatedItemsSection
            host={{
              basePath: `/development_pace_scenarios/${scenarioId}/area_configs/${id}`,
            }}
          />
        );
      }}
    </form.Subscribe>
  );
}
